
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/essays/[slug]",
      function () {
        return require("private-next-pages/essays/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/essays/[slug]"])
      });
    }
  